export default __webpack_public_path__ + "static/media/signup.36dbbe34.png";